const BonusCodeDetailsViewModelKeysTypeName = "BonusCodeDetailsViewModelKeys";
const BonusCodeQueryFieldsTypeName = "BonusCodeQueryFields";
export {
  BonusCodeDetailsViewModelKeysTypeName,
  BonusCodeQueryFieldsTypeName
};
//# sourceMappingURL=constants.js.map
